var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash01 = function SvgTrash01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.308 21.5q-.748 0-1.278-.53a1.74 1.74 0 0 1-.53-1.278V5h-1V3.5H9v-.885h6V3.5h5.5V5h-1v14.692q0 .758-.525 1.283t-1.283.525zM18 5H6v14.692a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087h11.385a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212zM9 17.5h1.5v-10H9zm4.5 0H15v-10h-1.5z"
  })));
};
export default SvgTrash01;